module.exports = __webpack_public_path__ + "static/img/background.d7285015.jpg";